// ---------------------------------------------------------------------------
// Website Tracking — config + visitor sessions (V2 Doc 45)
// ---------------------------------------------------------------------------

import { pgTable, uuid, text, varchar, jsonb, timestamp, index } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const websiteTrackingConfig = pgTable(
  "website_tracking_config",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    domain: text("domain").notNull(),
    scriptStatus: varchar("script_status", { length: 20 }).notNull().default("active"), // active | paused
    widgetConfig: jsonb("widget_config").notNull().default({}),
    popupRules: jsonb("popup_rules").notNull().default([]),
    consentMode: varchar("consent_mode", { length: 20 }).notNull().default("strict"), // strict | standard | off
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_website_tracking_tenant").on(table.tenantId),
  ],
);

export const visitorSessions = pgTable(
  "visitor_sessions",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    visitorId: text("visitor_id").notNull(), // anonymous cookie ID
    contactId: uuid("contact_id"), // linked when identified
    sessionStart: timestamp("session_start", tz).notNull().defaultNow(),
    sessionEnd: timestamp("session_end", tz),
    pages: jsonb("pages").notNull().default([]), // [{url, title, duration, scrollDepth}]
    source: text("source"),
    medium: text("medium"),
    campaign: text("campaign"),
    referrer: text("referrer"),
    device: text("device"),
    geo: text("geo"),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_visitor_sessions_tenant").on(table.tenantId, table.sessionStart),
    index("idx_visitor_sessions_visitor").on(table.tenantId, table.visitorId),
    index("idx_visitor_sessions_contact").on(table.tenantId, table.contactId),
  ],
);
